import { DeleteDialog } from "components";
import ConfirmCopyModal from "components/modals/ConfirmCopyModal";
import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";

interface Props {
  optionsPanelData: server.dto.OptionsPanelDataV2
  listUrl: string
  productTemplate: server.dto.ProductTemplate
}

const ProductTemplateDetailOptionsPanel = (props: Props) => {
  const { optionsPanelData } = props;
  const [isDeleting, setIsDeleting] = React.useState(false);
  const [isCopying, setIsCopying] = React.useState(false);

  const onDelete = async () => {
    await window.CoreApi.ProductTemplates.Delete({ productTemplateId: props.productTemplate.productTemplateId });
    window.location.href = props.listUrl;
  }

  const onCopy = async () => {
    const response = await window.CoreApi.ProductTemplates.Copy({ productTemplateId: props.productTemplate.productTemplateId });
    return response.data;
  }

  return <>
    <DeleteDialog
      spinForever
      isOpen={isDeleting}
      onDelete={onDelete}
      handleClose={() => { setIsDeleting(false); }}
      message={RESX.GeneralWarnings.DeleteSure}
    />
    <ConfirmCopyModal
      isOpen={isCopying}
      apiCall={onCopy}
      onClose={() => { setIsCopying(false); }}
      onSuccess={(itemId) => window.location.href = routes.productTemplate_Detail(itemId).absolute}
    />
    <GeneralOptionsPanel data={optionsPanelData} links={[{
      text: RESX.Buttons.ListView,
      href: routes.productTemplate_List().absolute,
      visible: true
    }, {
      text: RESX.Buttons.btnCopy,
      onClick: () => { setIsCopying(true); },
      visible: true
    }, {
      text: RESX.Buttons.btnDelete,
      onClick: () => { setIsDeleting(true) },
      visible: true
    }]} />
  </>;
};

export default ProductTemplateDetailOptionsPanel;